import { DatosReporte } from '../core/reporte';

export type VistaReporteDireccionTrabajo = 'tabla' | 'lre';

export interface FormatoReporteDireccionTrabajo extends DatosReporte {
    anio: boolean;
    vista: VistaReporteDireccionTrabajo;
}

const REPORTE_MORA_PREV: FormatoReporteDireccionTrabajo = {
    tituloReporte: 'Mora previsional',
    subtituloReporte: 'Consulta de mora previsional informada por la Dirección del Trabajo.',
    icono: 'pi pi-briefcase',
    anio: false,
    vista: 'tabla',
    tablas: [
        {
            datos: 'filas',
            titulo: 'Personas con mora previsional',
            subtitulo: 'Detalle vigente informado para el contribuyente seleccionado.',
            columnas: [
                { nombre: 'rutAfiliado', titulo: 'RUT afiliado' },
                { nombre: 'nombreAfiliado', titulo: 'Nombre afiliado' },
                { nombre: 'tipoProducto', titulo: 'Tipo de producto' },
                { nombre: 'institucionPrevisional', titulo: 'Institución previsional' },
                { nombre: 'periodoRegularizar', titulo: 'Período a regularizar' },
                { nombre: 'fechaCarta', titulo: 'Fecha carta' },
                { nombre: 'contacto', titulo: 'Contacto' },
                { nombre: 'telefonoContacto', titulo: 'Teléfono' },
                { nombre: 'correoContacto', titulo: 'Correo' },
                { nombre: 'fechaDemanda', titulo: 'Fecha demanda' }
            ]
        }
    ]
};

const REPORTE_LRE: FormatoReporteDireccionTrabajo = {
    tituloReporte: 'Libro de Remuneraciones Electrónico',
    tituloMenu: 'LRE',
    subtituloReporte: 'Remuneraciones declaradas mes a mes ante la Dirección del Trabajo.',
    icono: 'pi pi-book',
    anio: true,
    vista: 'lre',
    tablas: []
};

export const DIRECCION_TRABAJO_REPORTES_DATOS = {
    moraPrev: REPORTE_MORA_PREV,
    lre: REPORTE_LRE
} satisfies Record<string, FormatoReporteDireccionTrabajo>;

export type TipoReporteDireccionTrabajo = keyof typeof DIRECCION_TRABAJO_REPORTES_DATOS;
